import React, { lazy } from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PartnerWithUsProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
}
export const PartnerWithUs = ({
  openRegistrationForm,
  openHostSalonForm
}: PartnerWithUsProps) => {
  return <div className="pt-20" data-id="element-4241" data-mp="cebho92l0epu">
      <section className="py-16 bg-secondary/5" data-id="element-4242" data-mp="cel3rlkia1q9">
        <div className="container mx-auto px-4" data-id="element-4243" data-mp="7ma0q9ugxzth">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4244" data-mp="7kgsiq47j7jd">
            Partner With Us
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4245" data-mp="3ttrpggvxhfm8">
            Join forces with The Networking Salon to create meaningful
            connections, share resources, and build a stronger community
            together.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4246" data-mp="3kvfvc4vurzp1">
        <div className="container mx-auto px-4" data-id="element-4247" data-mp="2vjazcfy6469r">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-4248" data-mp="2vhhr4w7wpdzn">
            <div data-id="element-4249" data-mp="30bm01l0qfw3d">
              <h2 className="text-3xl font-bold text-secondary-dark mb-6" data-id="element-4250" data-mp="30c45975dhknf">
                Why Partner With Us?
              </h2>
              <div className="space-y-4" data-id="element-4251" data-mp="2qjyd9xf4f388">
                <p className="text-secondary" data-id="element-4252" data-mp="2ql11fxl26rkg">
                  The Networking Salon is a high-trust, multi-city professional
                  ecosystem bringing together 300+ professionals,
                  entrepreneurs, and educators across 9 active cities in
                  Nigeria, Germany, and Namibia. Our community is built on
                  authentic connections, resource sharing, and creating
                  opportunities.
                </p>
                <p className="text-secondary" data-id="element-4253" data-mp="1ttz5i56so8qp">
                  By partnering with us, your organization gains access to a
                  diverse network of engaged individuals who are actively
                  seeking to grow, collaborate, and make an impact in their
                  fields.
                </p>
                <p className="text-secondary" data-id="element-4254" data-mp="3vkpj5my9h38g">
                  We believe in creating partnerships that provide mutual value
                  and align with our mission of connecting young leaders to
                  networks, ideas, and opportunities worldwide.
                </p>
              </div>
            </div>
            <div data-id="element-4255" data-mp="3htayzcsmavzt">
              <Card className="p-0 overflow-hidden" data-id="element-4256" data-mp="3hpna4qy4axrf">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="The Networking Salon event" className="w-full h-64 object-cover" loading="lazy" data-id="element-4257" data-mp="3cs3v3otligyf" />
              </Card>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-4258" data-mp="160314jmym2as">
            <Card className="flex flex-col items-center text-center p-8" data-id="element-4259" data-mp="113vrafrg06nk">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-4260" data-mp="19jbl5x6tw5e0">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-4261" data-mp="1dkneodstparh"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-4262" data-mp="1idzohhsufd06">
                Event Collaborations
              </h3>
              <p className="text-secondary" data-id="element-4263" data-mp="1ndvxjvgeduml">
                Co-create workshops, panels, and networking events that bring
                value to both our communities.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-4264" data-mp="uox9khplfy9d">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-4265" data-mp="zkvshps5ko2e">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-4266" data-mp="14j71xzejcwk3"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-4267" data-mp="2b3ghohoaexxg">
                Resource Sharing
              </h3>
              <p className="text-secondary" data-id="element-4268" data-mp="3ox3w69d3cx5l">
                Exchange knowledge, tools, and platforms to support each other's
                growth and impact.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-4269" data-mp="1sfq68oea2pt">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-4270" data-mp="1ql58ud4ialq">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-4271" data-mp="bqvhabnf9bzb"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-4272" data-mp="6rs9wkjyyto6">
                Community Connections
              </h3>
              <p className="text-secondary" data-id="element-4273" data-mp="kjfauxouwqda">
                Access our network of professionals and help your audience find
                valuable connections.
              </p>
            </Card>
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200 mb-16" data-id="element-4274" data-mp="ui4r6m13u2rf">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6 text-center" data-id="element-4275" data-mp="pjbdashwo9qq">
              Get In Touch
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4276" data-mp="194toch7vw3un">
              <Card className="flex flex-col items-center text-center p-6" data-id="element-4277" data-mp="1e23mcl9c9nu3">
                <Mail size={32} className="mb-4 text-secondary" data-id="element-4278" data-mp="z6dwud4y2skm" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-4279" data-mp="z7yre2r9ebih">
                  Email Us
                </h3>
                <p className="text-secondary mb-4" data-id="element-4280" data-mp="qdu7626mrybx">
                  Send us a message to discuss partnership opportunities.
                </p>
                <a href="mailto:partner@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4281" data-mp="v52dgpcnz3kv">
                  partner@thenetworkingsalon.live
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-4282" data-mp="7eycyqurvjy3">
                <Instagram size={32} className="mb-4 text-secondary" data-id="element-4283" data-mp="7gswc0qeb402" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-4284" data-mp="bfs0vk87syqz">
                  Instagram
                </h3>
                <p className="text-secondary mb-4" data-id="element-4285" data-mp="2e51pxsuardzb">
                  Follow us for updates and direct message us.
                </p>
                <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-4286" data-mp="24cm6er3cqhcb">
                  @thenetworkingsalon
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-4287" data-mp="2s3rn18h49dno">
                <Linkedin size={32} className="mb-4 text-secondary" data-id="element-4288" data-mp="2n33vmloz6usx" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-4289" data-mp="2n5hs8yzb0f2l">
                  LinkedIn
                </h3>
                <p className="text-secondary mb-4" data-id="element-4290" data-mp="1bozsaowhzub7">
                  Connect with us professionally and explore our content.
                </p>
                <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-4291" data-mp="17lbmobrff8sl">
                  The Networking Salon
                </a>
              </Card>
            </div>
          </div>
          <div className="text-center" data-id="element-4292" data-mp="wikbw78ghd8">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-4293" data-mp="xjyi9jjpjz6">
              Join Our Community
            </h2>
            <p className="text-secondary mb-8 max-w-2xl mx-auto" data-id="element-4294" data-mp="5xoii9jnwwu5">
              Want to be part of The Networking Salon? Join as a member or host
              a salon in your city.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-4295" data-mp="eu78bcwlk4mi">
              <Link to="/joinnow" data-id="element-4296" data-mp="jul51ysqzs58">
                <Button data-id="element-4297" data-mp="2gnekidgwy646">Join a Salon</Button>
              </Link>
              <Button variant="outline" onClick={openHostSalonForm} data-id="element-4298" data-mp="2goy3wcxv8xa6">
                Host a Salon
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};